export default {
      id: "Icon--info-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--info",
      toString: function () {
        return this.url;
      }
    }